import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'link',
})
export class LinkPipe implements PipeTransform {
  transform(value: string | undefined, type: 'route' | 'href' | 'modal'): string | undefined {
    if (value && value.endsWith('-modal')) {
      return type === 'modal' ? value : undefined;
    } else if (value && (value.startsWith('/') || value.startsWith('https://mototechna.cz/') || value.startsWith('https://www.mototechna.cz/'))) {
      return type === 'route' ? value : undefined;
    } else {
      return type === 'href' ? value : undefined;
    }
  }
}
